var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 37,
    viewBox: "0 0 52 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#1F2765"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 31,
    r: 5,
    fill: "#4151CA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 5,
    r: 5,
    fill: "#4151CA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 32,
    r: 5,
    fill: "#4151CA"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 31,
    r: 5,
    fill: "#1F2765"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 18,
    r: 5,
    fill: "#1F2765"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 18,
    r: 5,
    fill: "#4151CA"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 5,
    fill: "#1F2765"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 18,
    r: 5,
    fill: "#1F2765"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 5,
    r: 5,
    fill: "#4151CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.df31dbca6007bec531329b3a3e63e58b.svg";
export { ForwardRef as ReactComponent };